import { useState, useEffect } from 'react'
import themeVariables from '../theme-variables.js'

// Convert rem values from theme-variables to pixels (assuming 1rem = 16px)
const convertRemToPx = (remValue) => {
  return parseFloat(remValue) * 16
}

// Extract breakpoints from theme-variables and convert to pixels
const breakpoints = {
  xs: convertRemToPx(themeVariables.default.breakpoints.xs),
  sm: convertRemToPx(themeVariables.default.breakpoints.sm),
  md: convertRemToPx(themeVariables.default.breakpoints.md),
  lg: convertRemToPx(themeVariables.default.breakpoints.lg),
  xl: convertRemToPx(themeVariables.default.breakpoints.xl),
  xxl: convertRemToPx(themeVariables.default.breakpoints.xxl),
  xxxl: convertRemToPx(themeVariables.default.breakpoints.xxxl),
  xxxxl: convertRemToPx(themeVariables.default.breakpoints.xxxxl)
}

export const useResponsiveBreakpoint = () => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState('xl')
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  )

  useEffect(() => {
    if (typeof window === 'undefined') return

    const handleResize = () => {
      const width = window.innerWidth
      setWindowWidth(width)

      // Determine current breakpoint
      let breakpoint = 'xs'
      if (width >= breakpoints.xxxxl) breakpoint = 'xxxxl'
      else if (width >= breakpoints.xxxl) breakpoint = 'xxxl'
      else if (width >= breakpoints.xxl) breakpoint = 'xxl'
      else if (width >= breakpoints.xl) breakpoint = 'xl'
      else if (width >= breakpoints.lg) breakpoint = 'lg'
      else if (width >= breakpoints.md) breakpoint = 'md'
      else if (width >= breakpoints.sm) breakpoint = 'sm'

      setCurrentBreakpoint(breakpoint)
    }

    // Set initial values
    handleResize()

    // Add event listener
    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // Helper functions for breakpoint checks
  const isAbove = (breakpoint) => windowWidth >= breakpoints[breakpoint]
  const isBelow = (breakpoint) => windowWidth < breakpoints[breakpoint]
  const isBetween = (minBreakpoint, maxBreakpoint) => 
    windowWidth >= breakpoints[minBreakpoint] && windowWidth < breakpoints[maxBreakpoint]

  return {
    currentBreakpoint,
    windowWidth,
    isAbove,
    isBelow,
    isBetween,
    breakpoints,
    themeBreakpoints: themeVariables.default.breakpoints
  }
}
